/* eslint-disable import/prefer-default-export */
export const TrackingKeys = {
    TOPLIST: 'toplist',
    BONUS: 'bonus',
    BONUSBOX: 'bonus_box',
    OPERATORBANNER: 'header',
    HEADEROPERATOR: 'header',
    HEADERPAYMENT: 'header',
    HEADERSLOTS: "header",
    POPUP: "popup",
    ODDSTABLE: 'odds_table',
    CARDS: 'cards',
    CONTENT: 'content',
    INFOGRID: "information_grid",
    COMPARISONTABLE: 'comparison_table',
    OPERATORSUMMARY: "expert_review_summary",
    WAGERINGCALCULATOR: 'wagering_calculator',
    NAVIGATIONTOPLIST: 'navigation_toplist',
    WELCOMEBONUS: 'welcome_bonus',
    OPERATORSTABLE: 'comparison_table',
    LOTTO: 'lotto',
    NAVIGATIONEXLUSIVE: 'navigation_exclusive',
    HEADER: {
        TOPLIST: 'header_toplist',
        BONUS: "header_bonus"
    }
}

